import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaMapMarkerAlt, FaMap } from 'react-icons/fa';

const MapLocation = ({ address }) => {
  const encodedAddress = encodeURIComponent(address);
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  const embedUrl = `https://maps.google.com/maps?q=${encodedAddress}&t=k&z=17&ie=UTF8&iwloc=&output=embed`; // t=k for satellite, z=17 for closer zoom

  return (
    <Card className="shadow-lg rounded-4 border-0 my-4 overflow-hidden">
      <div style={{ height: '300px', width: '100%' }}>
        <iframe
          src={embedUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Satellite Map Location"
        ></iframe>
      </div>
      <Card.Body className="text-center py-4">
        <Card.Title className="fs-4 fw-bold mb-3 " style={{color:'#54b435'}}>
          <FaMapMarkerAlt className="me-2 text-danger" />
          Location Preview
        </Card.Title>
        <Card.Text className="mb-4 text-muted fs-6">{address}</Card.Text>
        <Button
         
          onClick={() => window.open(mapLink, '_blank')}
          className="d-inline-flex align-items-center gap-2 px-4 py-2 btn-own" style={{width:'auto'}}
        >
          <FaMap />
          Open in Google Maps
        </Button>
      </Card.Body>
    </Card>
  );
};

export default MapLocation;
